<template>
  <div>
    <el-bread-crumb :bread-cumb="breadCrumb"/>
    <el-row>
      <el-col :span="12">
        <el-form :model="form" ref="formRef" :rules="rules" label-width="100px" v-loading="loading">
          <el-form-item label="活动名称" prop="activity_name">
            <el-input v-model="form.activity_name" placeholder="请输入" :maxlength="500"/>
          </el-form-item>
          <el-form-item label="活动店铺" prop="shop_id">
            <el-select v-model="form.shop_id" filterable remote clearable placeholder="请选择">
              <el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间" prop="time">
            <el-date-picker v-model="form.time" type="datetimerange" style="width: 100%;"
                            value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                            :default-time="['00:00:00', '23:59:59']"/>
          </el-form-item>
          <el-form-item label="活动简介" prop="brief">
            <el-input v-model="form.brief" placeholder="请输入" :maxlength="500"/>
          </el-form-item>
          <el-form-item label="活动介绍" prop="intro">
            <quill-editor ref="editor" v-model="form.intro" @change="onIntroChange"/>
          </el-form-item>
          <el-form-item label="活动人数" prop="number">
            <el-input-number v-model="form.number" :precision="0" :max="99999999" :min="1"/>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="back">取消</el-button>
            <el-button size="mini" type="primary" @click="submit" :loading="loading">提交</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <preview :data="form.intro"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ElBreadCrumb from '../../components/BreadCumb.vue'
import QuillEditor from "../../components/QuillEditor.vue";
import Preview from "./components/preview.vue";
import moment from 'moment';

export default {
  name: "activityForm",
  components: {
    Preview,
    ElBreadCrumb,
    QuillEditor,
  },
  data() {
    return {
      form: {
        activity_name: '',
        time: [],
        intro: '',
        brief: '',
        number: undefined,
        // 活动类型 1-养老社区活动
        activity_type: 1,
        shop_id: undefined
      },
      rules: {
        'activity_name': [{
          required: true, message: '请填写活动名称'
        }],
        'time': [{
          required: true, message: '请选择活动时间'
        }],
        'shop_id': [{
          required: true, message: '请选择活动店铺'
        }],
        'brief': [{
          required: true, message: '请填写活动简介'
        }],
        'intro': [{
          required: true, message: '请填写活动内容'
        }],
        'number': [{
          required: true, message: '请填写活动人数'
        }],
      },
      title: '',
      show: false,
      loading: false,
      isAdd: false,
      breadCrumb: [],
      shops: [],
    }
  },
  created() {
    this.breadCrumb = [
      {'name': '活动列表', 'path': `/activity/list/${this.$route.params.ruleId}`},
      {'name': this.$route.query.id ? '编辑活动' : '新增活动', 'path': ''}]
    try {
      this.shops = JSON.parse(localStorage.getItem('shops'));
    } catch (e) {
      this.shops = [];
    }
  },
  mounted() {
    this.initData(this.$route.query)
  },
  methods: {
    initData(row) {
      if (row && row.id) {
        this.title = '编辑活动';
        this.form.id = row.id;
        this.loadData();
        this.isAdd = false;
      } else {
        this.title = '新增活动';
        this.isAdd = true;
        this.form.id = undefined;
      }
      this.show = true;
    },
    loadData() {
      this.loading = true;
      this.$api.get_glue(this.$apiUrl.getActivityDetail, {id: this.form.id}, res => {
        this.loading = false;
        const data = res.data || {};
        this.form = {
          ...data,
          shop_id: data.shop_id ? data.shop_id + "" : undefined,
          time: data.begin_time && data.end_time ? [data.begin_time, data.end_time] : []
        };
      }, res => {
        this.loading = false;
      })
    },
    back() {
      if (this.loading) return;
      this.$router.back();
      this.$refs.formRef.resetFields();
    },
    onIntroChange({html, text}) {
      this.$set(this.form, 'intro', html == '<p><br></p>' ? '' : html);
      this.$nextTick(() => {
        this.$refs.formRef.validateField('intro')
      })
    },
    submit() {
      if (this.loading) return;
      this.loading = true;
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            begin_time: this.form.time && this.form.time[0] ? moment(this.form.time[0]).format('YYYY-MM-DD HH:mm') + ":00" : '',
            end_time: this.form.time && this.form.time[1] ? moment(this.form.time[1]).format('YYYY-MM-DD HH:mm') + ":59" : '',
            time: undefined,
            school_id: this.form.school_id || this.$store.getters.schoolId
          }
          if (this.isAdd) {
            params.create_user = this.$store.getters.userId;
          } else {
            params.update_user = this.$store.getters.userId;
          }
          this.$api.post_glue(this.isAdd ? this.$apiUrl.addActivity : this.$apiUrl.editActivity, params, (res) => {
            this.loading = false;
            if (res.result) {
              this.$message.success('提交成功');
              this.back();
            } else {
              this.$message.error(res.message);
            }
          }, (res) => {
            this.$message.error(res.message);
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      })
    },
    remoteShopMethod(query) {
      if (query !== '') {
        this.shopList = [];
        var arr = [];
        let len = this.shops.length;
        var reg = new RegExp(query);
        for (var i = 0; i < len; i++) {
          //如果字符串中不包含目标字符会返回-1
          if (this.shops[i].name.match(reg)) {
            this.shopList.push(this.shops[i]);
          }
        }
      } else {
        this.shopList = [];
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// activityForm.vue?5c4568ba